import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import {
  FLAG_GETTING_TICKET_REASSIGNMENTS,
  FLAG_TICKET_REASSIGNMENT_ACTIVITY,
  GET_TICKET_REASSIGNMENTS,
} from '../types';
import { isErrorResponse } from '../../utils/error-handlers';
import { DEFAULT_GET_CONFIG, DEFAULT_PUT_CONFIG } from '../../config/rest';
import { TICKET_REASSIGNMENT_ENDPOINT } from '../../config/endpoints';

const flagGettingTicketReassignments = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_TICKET_REASSIGNMENTS,
    payload: flag,
  });

const flagTicketReassignmentActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_TICKET_REASSIGNMENT_ACTIVITY,
    payload: flag,
  });

const getTicketReassignments = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingTicketReassignments(true));
    const query = tableFilters;
    const url = `${TICKET_REASSIGNMENT_ENDPOINT}?${QueryString.stringify(
      query,
    )}`;
    const promise = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(promise, null, dispatch);
    const response = await promise.json();
    dispatch({
      type: GET_TICKET_REASSIGNMENTS,
      payload: response,
    });
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagGettingTicketReassignments(false));
  }
};

const putTicketReassignment =
  async (
    ticketReassignmentId,
    { acceptMerge, negotiation, refundType, comment },
  ) =>
  async (dispatch) => {
    try {
      dispatch(flagTicketReassignmentActivity(true));
      const payload = {
        id: ticketReassignmentId,
        acceptMerge,
        negotiation,
        refundType,
        comment,
      };
      const url = `${TICKET_REASSIGNMENT_ENDPOINT}/${ticketReassignmentId}`;
      const promise = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(promise, null, dispatch);
      await promise.json();
      return true;
    } catch ({ message }) {
      toastr.error('Error', message);
      return false;
    } finally {
      dispatch(flagTicketReassignmentActivity(false));
    }
  };

export { getTicketReassignments, putTicketReassignment };
